import { render, staticRenderFns } from "./MailingAddress.vue?vue&type=template&id=505152d8&scoped=true&"
import script from "./MailingAddress.vue?vue&type=script&lang=js&"
export * from "./MailingAddress.vue?vue&type=script&lang=js&"
import style0 from "./MailingAddress.vue?vue&type=style&index=0&id=505152d8&lang=scss&scoped=true&"
import style1 from "./MailingAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505152d8",
  null
  
)

export default component.exports